import { render, staticRenderFns } from "./TextSuggest.vue?vue&type=template&id=0bd9f39a&scoped=true"
import script from "./TextSuggest.vue?vue&type=script&lang=ts"
export * from "./TextSuggest.vue?vue&type=script&lang=ts"
import style0 from "./TextSuggest.vue?vue&type=style&index=0&id=0bd9f39a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd9f39a",
  null
  
)

export default component.exports